var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCellFactoryChamber(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    x: "0px",
    y: "0px",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "svg_1"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "6.1,73.2 73.8,73.2 73.8,26.9 56.4,18.8 23.3,19 6.1,26.9  ",
    fill: "#FFFFFF",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6.1,
    y1: 62.8,
    x2: 73.8,
    y2: 62.8,
    fill: "none",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6.1,
    y1: 53.9,
    x2: 73.8,
    y2: 53.9,
    fill: "none",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6.2,
    y1: 45,
    x2: 73.8,
    y2: 45,
    fill: "none",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6.2,
    y1: 36.1,
    x2: 73.8,
    y2: 36.1,
    fill: "none",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6.2,
    y1: 27.1,
    x2: 73.8,
    y2: 27.1,
    fill: "none",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.2,7.1l-4.1,0c-0.4,0 -0.7,0.3 -0.7,0.7l0,11.2l5.6,0l0,-11.1c-0.1,-0.4 -0.4,-0.8 -0.8,-0.8z",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11,7.1l-4.1,0c-0.4,0 -0.7,0.3 -0.7,0.7l0,18.3l5.6,0l0,-18.2c0,-0.4 -0.4,-0.8 -0.8,-0.8z",
    stroke: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCellFactoryChamber);
export default __webpack_public_path__ + "static/media/cellFactoryChamber.9db8620f13941c36eaa9e8c760f3357e.svg";
export { ForwardRef as ReactComponent };